module.exports = __webpack_public_path__ + "img/solutions-landing-bg.f355b9ff.png";